module.exports = __webpack_public_path__ + "static/media/2DGACM15.224e861d.jpg";